import { useTranslation } from 'react-i18next';
import SearchableSelect from '../searchableSelect/searchableSelect';
import { useMatterRequestBusinessAreaSelect } from './useMatterRequestBusinessAreaSelect';

interface MatterRequestBusinessAreaSelectProps {
  onOpenPicker: () => void;
  onClear: () => void;
}

/**
 * Its own component so the business area list is only fetched where the field is rendered. It
 * renders the trigger button directly, which lookup siblings like `LookupClearButton` rely on.
 */
const MatterRequestBusinessAreaSelect = ({
  onOpenPicker,
  onClear,
}: Readonly<MatterRequestBusinessAreaSelectProps>) => {
  const { t } = useTranslation();
  const select = useMatterRequestBusinessAreaSelect();

  return (
    <SearchableSelect
      {...select}
      ariaLabel={t('matter:businessArea')}
      placeholder={t('matterRequest:selectBusinessArea')}
      searchPlaceholder={t('matterRequest:searchBusinessAreas')}
      onSearchIconClick={onOpenPicker}
      onClear={onClear}
      data-testid="select-business-area-button"
    />
  );
};

export default MatterRequestBusinessAreaSelect;
